import { Injectable } from '@angular/core';
import { SsrCookieService as CookieService } from 'ngx-cookie-service-ssr';
import { Shop } from '../entities/shop';
import { ActivatedRoute, Router } from '@angular/router';
import { PlatformInformationService } from '../../../../projects/platform-manager/src/public_api';

@Injectable({
  providedIn: 'root'
})
export class ShopSortingService {
  private sortSelectionVal = 'price_distance'; // the selected value for the sort order
  private isBrowser: boolean; // tells you if the current execution is on Server or Browser

  getCurrentSelection() {
    return this.sortSelectionVal;
  }

  constructor(
    protected cookieService: CookieService,
    private platformService: PlatformInformationService,
    protected router: Router,
    protected route: ActivatedRoute
  ) {
    this.isBrowser = this.platformService.getIsBrowser();
    if (this.isBrowser) {
      if (this.cookieService.get('sortBy')) {
        this.sortSelectionVal = this.cookieService.get('sortBy') as string;
      }
    }
  }

  /**
   * sorts a shops array accoring to sortBy case
   * @param sortBy what do you want to sort by?
   * @param shops which array do you want to sort?
   *
   * Three different possibilities:
   *
   * a) price: Function returns Array which is sorted by price
   * b) distance: Function returns Array which is sorted by distance
   * c) price and distance: Function returns Array which is sorted by price and distance
   */
  sortShops(sortBy = 'price_distance', shops: Array<Shop>) {
    if (this.sortSelectionVal.localeCompare(sortBy) !== 0) {
      if (this.isBrowser && sortBy != 'hotel') {
        this.cookieService.set('sortBy', sortBy);
      }
    }
    this.sortSelectionVal = sortBy;
    switch (sortBy) {
      case 'price':
        shops = shops.sort((n1, n2) => {
          if (n1.defaultProductOnlinePriceRaw > n2.defaultProductOnlinePriceRaw) {
            return 1;
          }
          if (n1.defaultProductOnlinePriceRaw < n2.defaultProductOnlinePriceRaw) {
            return -1;
          }
          return 0;
        });
        return shops;
      case 'distance':
        shops = shops.sort((n1, n2) => {
          if (n1.distance > n2.distance) {
            return 1;
          }
          if (n1.distance < n2.distance) {
            return -1;
          }
          return 0;
        });
        return shops;
      case 'price_distance':
        shops = shops.sort((n1, n2) => {
          if (n1.position > n2.position) {
            return 1;
          }

          if (n1.position < n2.position) {
            return -1;
          }
          return 0;
        });
        return shops;
      case 'hotel':
        // walkin > driving > no route found
        shops = shops.sort((n1, n2) => {
          const shopDistance1 = n1.hotelDistance.distanceMeters ?? n1.hotelDistance.distanceMetersCar;
          const shopDistance2 = n2.hotelDistance.distanceMeters ?? n2.hotelDistance.distanceMetersCar;

          if (shopDistance1 && shopDistance2) {
            if (shopDistance1 > shopDistance2) {
              return 1;
            }
            if (shopDistance1 < shopDistance2) {
              return -1;
            }
          }
          if (shopDistance1 && !shopDistance2) {
            return -1;
          }
          if (!shopDistance1 && shopDistance2) {
            return 1;
          }
          return 0;
        });
        return shops;
    }
  }

  /**
   * Function to sort multidimensional array
   *
   * param {array} [arr] Source array
   * param {array} [columns] List of columns to sort
   * param {array} [order_by] List of directions (ASC, DESC)
   * returns {array}
   */
  // multisort(arr: Array<Array<unknown>>, columns: Array<number>, order_by: Array<string>) {
  //   if (typeof columns === 'undefined') {
  //     columns = [];
  //     for (let x = 0; x < arr[0].length; ++x) {
  //       columns.push(x);
  //     }
  //   }

  //   if (typeof order_by === 'undefined') {
  //     order_by = [];
  //     for (let x = 0; x < arr[0].length; ++x) {
  //       order_by.push('ASC');
  //     }
  //   }

  //   function multisort_recursive(a, b, _columns, _order_by, index) {
  //     const direction = _order_by[index] === 'DESC' ? 1 : 0;

  //     const is_numeric = !isNaN(+a[_columns[index]] - +b[_columns[index]]);
  //     const x = is_numeric ? +a[_columns[index]] : a[_columns[index]].toLowerCase();
  //     const y = is_numeric ? +b[_columns[index]] : b[_columns[index]].toLowerCase();

  //     if (x < y) {
  //       return direction === 0 ? -1 : 1;
  //     }

  //     if (x === y) {
  //       return _columns.length - 1 > index ? multisort_recursive(a, b, _columns, _order_by, index + 1) : 0;
  //     }

  //     return direction === 0 ? 1 : -1;
  //   }

  //   return arr.sort(function (a, b) {
  //     return multisort_recursive(a, b, columns, order_by, 0);
  //   });
  // }
}
